/* eslint-disable camelcase */
import React from "react";
import { Image } from "semantic-ui-react";
import { useTranslation } from "ceco-polyglot";
import { ActionsTable } from "ceco-window-table";
import { AlertDeleteModal } from "../../modals/AlertDeleteModal";
import { AlertModal } from "../../modals/AlertModal";
import { MoreHorizontal, Edit, Delete } from "ceicons";
import DropDownButton from "../../DropDownButton";

export default function AlertsTable(props) {
  const { _refetch, totalCount, alertsParsed, handleScroll } = props;

  const t = useTranslation();

  const columnsTable = [
    {
      key: "icon",
      basis: 1,
      width: 100,
      ItemRenderer: PictureCell,
    },
    {
      key: "slugName",
      basis: 1,
      width: 200,
      title: t("table-header.name"),
    },
    {
      key: "description",
      basis: 1,
      title: t("table-header.description"),
    },
    {
      key: "id",
      basis: 1,
      width: 100,
      ItemRenderer: <EditCell refetchData={_refetch} />,
    },
  ];

  return (
    <ActionsTable
      actions={[]}
      allowItemSelection={false}
      footer={
        <div>
          <div className="legend" />
        </div>
      }
      allowAllItemsSelection={false}
      gridActions={[
        <div className="right floated" key="right-side">
          <strong>
            {totalCount} {t("count.alerts")}
          </strong>
        </div>,
      ]}
      items={alertsParsed}
      columns={columnsTable}
      onScrollTable={handleScroll}
    />
  );
}

const EditCell = (props) => {
  const { data, rowIndex, columnIndex, style, refetchData } = props;
  const { items } = data;

  const id = items[rowIndex][columnIndex];
  const slugName = items[rowIndex][columnIndex - 2];
  const description = items[rowIndex][columnIndex - 1];
  const icon = items[rowIndex][columnIndex - 3];

  const t = useTranslation();

  return (
    <div
      role="cell"
      style={{
        ...style,
        flexGrow: 1,
        flexDirection: "row",
        padding: "1em",
        border: "",
      }}
      className="edit cell"
    >
      <DropDownButton icon={<MoreHorizontal />}>
        <AlertModal
          alert={{ id, slugName, description, icon }}
          refetchData={refetchData}
          edit
          trigger={
            <div>
              <Edit />
              <p>{t("popup.edit")}</p>
            </div>
          }
        />
        <AlertDeleteModal
          alertName={slugName}
          refetchData={refetchData}
          alertId={id}
          trigger={
            <div className="delete-modal">
              <Delete />
              <p>{t("popup.remove")}</p>
            </div>
          }
        />
      </DropDownButton>
    </div>
  );
};

const PictureCell = (props) => {
  const { data, rowIndex, columnIndex, style } = props;
  const { items } = data;

  const icon = items[rowIndex][columnIndex];

  return (
    <div
      role="cell"
      style={{
        ...style,
        flexGrow: 1,
        padding: "1em",
        border: "",
      }}
      className="cell"
    >
      <Image src={icon} avatar />
    </div>
  );
};
